import { Flex, VStack } from '@chakra-ui/react';
import { Heading, Paragraph } from '../../..';

export interface Props {
  title: string;
  body: string;
  logoUrl: string;
  imageUrl: string;
}
export function MaintenanceScreen(props: Props): JSX.Element {
  return (
    <>
      <Flex justifyContent="center" alignItems="center">
        <VStack mt={'space_unit.x5'}>
          <img
            src={props.logoUrl}
            alt="Payflip Logo"
            style={{ width: '12%' }}
          />
          <img
            src={props.imageUrl}
            alt="Maintenance"
            style={{ marginLeft: '45px', width: '28%' }} // this margin is needed since the image is not centered and looks off otherwise
          />
          <Heading
            fontFamily={'Poppins'}
            mt={'space_unit.x4'}
            as="h1"
            variant="h2"
          >
            {props.title}
          </Heading>
          <Paragraph
            fontFamily={'Poppins'}
            textColor={'palette_gray.70'}
            textAlign={'center'}
          >
            {props.body}
          </Paragraph>
        </VStack>
      </Flex>
    </>
  );
}
